import * as React from 'react';
import { DeleteButton } from 'sos-eservice-common/js/components/General/DeleteButton';
import { Icon } from 'sos-common/js/components/Icon/icon';
import { makeTranslator } from 'sos-common/js/utils/translations';
import { setInnerHtml } from 'sos-common/js/utils/helpers';
import { RadioButtonGroup } from 'sos-common/js/components/FormControls/RadioButtonGroup';
import { RadioButton } from 'sos-common/js/components/FormControls/RadioButton';
import { ComboboxWithSearchFormControl } from 'sos-common/js/components/FormControls/ComboboxWithSearchFormControl';
import {
  MultiSelectComboboxFormControl,
  IMultiSelectComboboxFormControlProps,
} from 'sos-common/js/components/FormControls/MultiSelectComboboxFormControl';
import { TextInput, TextInputProps } from 'sos-common/js/components/FormControls/TextInput';
import { CheckBox, CheckBoxState, CheckBoxProps } from 'sos-common/js/components/FormControls/CheckBox';
import { SelectBox, SelectBoxProps } from 'sos-common/js/components/FormControls/SelectBox';
import { Fileupload } from 'sos-common/js/components/Fileupload/Fileupload';
import { IFileUploadProps } from 'sos-common/js/components/Fileupload/Fileupload.types';
import {
  FileUploadText,
  SpecialistbevisAnsokan,
  SpecialistbevisAnsokanFormStepOneModel,
  SpecialistbevisAnsokanPayload,
  LegitimationsDetalj,
  SpecialistbevisDetalj,
} from '../../../models/specialistbevisansokan.model';
import { EducationLocation } from '../../../models/ansokan.model';
import AttentionBox from 'sos-common/js/components/AttentionBox/Attentionbox';

import {
  SpecialistbevisAnsokanFormFieldName,
  ISpecAnsokanFormProps,
  ISpecAnsokanFormState,
  SpecialistbevisAnsokanField,
  SpecialistbevisYrke,
  SpecialistbevisTyp,
  MultiSelectItem,
  LEGITIMATION_MAX_ENTRIES,
  LEGITIMATION_MIN_ENTRIES,
  getLegitimationCountryFieldName,
  getLegitimationDateFieldName,
  createEmptyLegitimationEntry,
  EARLIER_SPECIALIST_MAX_ENTRIES,
  getEarlierSpecialistSpecialityFieldName,
  getEarlierSpecialistCountryFieldName,
  getEarlierSpecialistDateFieldName,
  createEmptyEarlierSpecialistEntry,
} from './SpecialistbevisAnsokanForm.types';
import { saveAnsokan } from '../../../services/ansokanform.save.service';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';
import LoadingSpinner from 'sos-common/js/components/LoadingSpinner/LoadingSpinner';
import { SpecialistbevisFieldMap } from './SpecialistbevisFieldMap';
import { FileExtendedDetails, FileState } from 'sos-common/js/commonTypes/fileupload.types';
import { doDelete, doPost } from 'sos-eservice-common/js/services/fetch.service';
import { ResponseError } from 'sos-common/js/utils/ResponseError';
import { DialogueError } from 'sos-common/js/components/DialogueError/DialogueError';
import { getDialogueByResponse } from '../../../helpers/dialogue.helper';
import { findFileUploadTextByFieldName, getFileUploadTexts } from '../../../helpers/fileUploadHelpers';

let ModalTranslate: (key: string, defaultValue?: string) => string;
let Translations: (key: string, defaultValue?: string) => string;

type LegitimationFieldKey = 'LandId' | 'Datum';
interface LegitimationFieldInfo {
  index: number;
  key: LegitimationFieldKey;
}
type EarlierSpecialistFieldKey = 'Specialitet' | 'LandId' | 'Datum';
interface EarlierSpecialistFieldInfo {
  index: number;
  key: EarlierSpecialistFieldKey;
}
export class SpecialistbevisAnsokanForm extends React.Component<ISpecAnsokanFormProps, ISpecAnsokanFormState> {
  private _latestResponseError: ResponseError;
  private readonly API_ROUTE =
    this.props.educationLocation === EducationLocation.EducatedInSweden
      ? '/_api/specialistbevis/se'
      : '/_api/specialistbevis';

  constructor(props: ISpecAnsokanFormProps) {
    super(props);

    ModalTranslate = makeTranslator(props.modalTranslations);
    Translations = makeTranslator(props.translations);
    const initialLegitimationEntries = this.getInitialLegitimationEntries(props.ansokan);
    const initialEarlierSpecialistEntries = this.getInitialEarlierSpecialistEntries(props.ansokan);
    const fieldMap = new SpecialistbevisFieldMap(
      props.model,
      props.ansokan,
      props.formTexts,
      props.educationLocation,
      props.specialistBevisTyp,
      Translations,
      this.addFile,
      this.removeFile,
      this.addMultiSelectItem,
      this.props.isOutsideEuEes,
      this.props.specialistBevisTypeOtherId,
      initialLegitimationEntries,
      initialEarlierSpecialistEntries,
    );

    fieldMap.addOnChangeEventHandler(this.inputChanged, this.onChangeTermsAndCondition);

    this.state = {
      fieldMap,
      payload: this.getDefaultPayload(props.ansokan),
      showSpinner: false,
      isLoading: false,
      isSaveErrorModalOpen: false,
      showAddressInfo: false,
      certInOtherCountry: this.props.ansokan.SpecialistbevisUtbildning?.SpecialistbevisFranAnnatLand ?? false,
      showOvrigSpecialistbevisTyp:
        this.props.ansokan.SpecialistbevisUtbildning?.TypAvSpecialistKompetensId ===
        this.props.specialistBevisTypeOtherId,
      legitimationEntries: initialLegitimationEntries,
      earlierSpecialistEntries: initialEarlierSpecialistEntries,
    };
  }

  componentDidMount() {
    let mailfields = document.querySelectorAll('#Epost,#BekraftaEpost');

    //.foreach() does not work in IE
    for (let index = 0; index < mailfields.length; index++) {
      const element = mailfields[index];
      element.addEventListener('paste', (e: ClipboardEvent) => {
        e.preventDefault();
      });
    }
  }

  onChangeTermsAndCondition = (field: CheckBoxState) => {
    const fieldMap = this.state.fieldMap.clone();
    const fieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.TermsAndConditions);
    fieldState.props.value = field.value;
    fieldMap.validateAllFieldsWithErrorMessages();
    this.setState({ fieldMap: fieldMap.clone() });
  };

  getDefaultPayload = (ansokan: SpecialistbevisAnsokan): SpecialistbevisAnsokanPayload => {
    const tandlakarPraktikLand =
      ansokan.SpecialistbevisUtbildning?.TandlakarPraktikDetalj?.LandId ??
      ansokan.SpecialistbevisUtbildning?.AllmanTandlakarpraktikLandId ??
      null;
    const tandlakarPraktikDatum =
      ansokan.SpecialistbevisUtbildning?.TandlakarPraktikDetalj?.Datum ??
      ansokan.SpecialistbevisUtbildning?.AllmanTandlakarpraktikDatum ??
      null;
    return {
      UtbildningslandId: ansokan.SpecialistbevisUtbildning?.UtbildningslandId ?? null,
      SpecialistBevisTyp: ansokan.SpecialistbevisUtbildning?.SpecialistBevisTyp ?? null,
      AnsokanId: ansokan.Id,
      Epost: ansokan.Epost ?? null,
      AccepteratVillkor: ansokan.AccepteratVillkor ?? null,
      YrkeId: this.props.model.OccupationId,
      SpecBehorighetsbevisFranAnnatLand: ansokan.SpecialistbevisUtbildning?.SpecialistbevisFranAnnatLand ?? null,
      [SpecialistbevisAnsokanFormFieldName.GeneralDentalPracticeCountry]: tandlakarPraktikLand,
      [SpecialistbevisAnsokanFormFieldName.GeneralDentalPracticeDate]: tandlakarPraktikDatum,
      [SpecialistbevisAnsokanFormFieldName.GeneralServiceCertificateDate]:
        ansokan.SpecialistbevisUtbildning?.BasTjanstgoringsDatum ??
        ansokan.SpecialistbevisUtbildning?.BastjanstgoringsIntygDatum ??
        null,
      [SpecialistbevisAnsokanFormFieldName.WorkPlace]:
        ansokan.SpecialistbevisUtbildning?.Arbetsplats ?? ansokan.Arbetsplats ?? null,
      [SpecialistbevisAnsokanFormFieldName.ExaminationDate]: ansokan.SpecialistbevisUtbildning?.ExamensDatum ?? null,
      LegitimationsDetaljer: ansokan.SpecialistbevisUtbildning?.LegitimationsDetaljer ?? [],
      SpecialistbevisDetaljer: ansokan.SpecialistbevisUtbildning?.SpecialistbevisDetaljer ?? [],
      TandlakarPraktikDetalj:
        tandlakarPraktikLand !== null || tandlakarPraktikDatum !== null
          ? { LandId: tandlakarPraktikLand, Datum: tandlakarPraktikDatum }
          : undefined,
    };
  };

  getInitialLegitimationEntries = (ansokan: SpecialistbevisAnsokan): LegitimationsDetalj[] => {
    const storedEntries = ansokan.SpecialistbevisUtbildning?.LegitimationsDetaljer ?? [];
    const normalized = storedEntries.slice(0, LEGITIMATION_MAX_ENTRIES);
    if (normalized.length === 0) {
      return [createEmptyLegitimationEntry()];
    }
    return normalized;
  };

  getInitialEarlierSpecialistEntries = (ansokan: SpecialistbevisAnsokan): SpecialistbevisDetalj[] => {
    const storedEntries = ansokan.SpecialistbevisUtbildning?.SpecialistbevisDetaljer ?? [];
    return storedEntries.slice(0, EARLIER_SPECIALIST_MAX_ENTRIES);
  };

  updateLegitimationEntriesArray = (index: number, key: LegitimationFieldKey, value: string): LegitimationsDetalj[] => {
    const entries = this.state.legitimationEntries.map((entry) => ({ ...entry }));
    if (!entries[index]) {
      return entries;
    }
    entries[index][key] = value;
    return entries;
  };

  sanitizeLegitimationEntriesForPayload = (entries: LegitimationsDetalj[]) =>
    entries
      .filter((entry) => (entry?.LandId ?? '') !== '' && (entry?.Datum ?? '') !== '')
      .map((entry) => ({
        LandId: entry?.LandId ?? null,
        Datum: entry?.Datum ?? null,
      }));

  parseLegitimationFieldName = (fieldName: string): LegitimationFieldInfo => {
    if (!fieldName) return null;
    const countryPrefix = `${SpecialistbevisAnsokanFormFieldName.LegitimationCountry}-`;
    const datePrefix = `${SpecialistbevisAnsokanFormFieldName.LegitimationDate}-`;

    if (fieldName.startsWith(countryPrefix)) {
      const index = parseInt(fieldName.replace(countryPrefix, ''), 10);
      if (!isNaN(index)) {
        return { index, key: 'LandId' };
      }
    }

    if (fieldName.startsWith(datePrefix)) {
      const index = parseInt(fieldName.replace(datePrefix, ''), 10);
      if (!isNaN(index)) {
        return { index, key: 'Datum' };
      }
    }

    return null;
  };

  updateLegitimationFieldStates = (entries: LegitimationsDetalj[], fieldMap: SpecialistbevisFieldMap) => {
    for (let index = 0; index < LEGITIMATION_MAX_ENTRIES; index++) {
      const entry = entries[index];
      const shouldShow = index < entries.length;
      const countryField = fieldMap.get(getLegitimationCountryFieldName(index));
      const dateField = fieldMap.get(getLegitimationDateFieldName(index));

      if (countryField) {
        countryField.ShowField = shouldShow;
        countryField.props.isRequired = shouldShow;
        countryField.props.value = entry?.LandId ?? '';
      }

      if (dateField) {
        dateField.ShowField = shouldShow;
        dateField.props.isRequired = shouldShow;
        dateField.props.value = entry?.Datum ?? '';
      }
    }
  };

  updateEarlierSpecialistEntriesArray = (
    index: number,
    key: EarlierSpecialistFieldKey,
    value: string,
  ): SpecialistbevisDetalj[] => {
    const entries = this.state.earlierSpecialistEntries.map((entry) => ({ ...entry }));
    if (!entries[index]) {
      return entries;
    }
    entries[index][key] = value;
    return entries;
  };

  sanitizeEarlierSpecialistEntriesForPayload = (entries: SpecialistbevisDetalj[]) =>
    entries
      .filter(
        (entry) => (entry?.Specialitet ?? '') !== '' && (entry?.LandId ?? '') !== '' && (entry?.Datum ?? '') !== '',
      )
      .map((entry) => ({
        Specialitet: entry?.Specialitet ?? null,
        LandId: entry?.LandId ?? null,
        Datum: entry?.Datum ?? null,
      }));

  parseEarlierSpecialistFieldName = (fieldName: string): EarlierSpecialistFieldInfo => {
    if (!fieldName) return null;
    const specialityPrefix = `${SpecialistbevisAnsokanFormFieldName.EarlierSpecialstCompetence}-speciality-`;
    const countryPrefix = `${SpecialistbevisAnsokanFormFieldName.EarlierSpecialstCompetence}-country-`;
    const datePrefix = `${SpecialistbevisAnsokanFormFieldName.EarlierSpecialstCompetence}-date-`;

    if (fieldName.startsWith(specialityPrefix)) {
      const index = parseInt(fieldName.replace(specialityPrefix, ''), 10);
      if (!isNaN(index)) {
        return { index, key: 'Specialitet' };
      }
    }

    if (fieldName.startsWith(countryPrefix)) {
      const index = parseInt(fieldName.replace(countryPrefix, ''), 10);
      if (!isNaN(index)) {
        return { index, key: 'LandId' };
      }
    }

    if (fieldName.startsWith(datePrefix)) {
      const index = parseInt(fieldName.replace(datePrefix, ''), 10);
      if (!isNaN(index)) {
        return { index, key: 'Datum' };
      }
    }

    return null;
  };

  updateEarlierSpecialistFieldStates = (entries: SpecialistbevisDetalj[], fieldMap: SpecialistbevisFieldMap) => {
    for (let index = 0; index < EARLIER_SPECIALIST_MAX_ENTRIES; index++) {
      const entry = entries[index];
      const shouldShow = index < entries.length;
      const specialityField = fieldMap.get(getEarlierSpecialistSpecialityFieldName(index));
      const countryField = fieldMap.get(getEarlierSpecialistCountryFieldName(index));
      const dateField = fieldMap.get(getEarlierSpecialistDateFieldName(index));

      if (specialityField) {
        specialityField.ShowField = shouldShow;
        specialityField.props.isRequired = shouldShow;
        specialityField.props.value = entry?.Specialitet ?? '';
      }

      if (countryField) {
        countryField.ShowField = shouldShow;
        countryField.props.isRequired = shouldShow;
        countryField.props.value = entry?.LandId ?? '';
      }

      if (dateField) {
        dateField.ShowField = shouldShow;
        dateField.props.isRequired = shouldShow;
        dateField.props.value = entry?.Datum ?? '';
      }
    }
  };

  addLegitimationEntry = () => {
    if (this.state.legitimationEntries.length >= LEGITIMATION_MAX_ENTRIES) return;
    const fieldMap = this.state.fieldMap;
    const newEntries = [...this.state.legitimationEntries, createEmptyLegitimationEntry()];
    this.updateLegitimationFieldStates(newEntries, fieldMap);
    this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
    this.setState((prevState) => ({
      ...prevState,
      legitimationEntries: newEntries,
      fieldMap: fieldMap.clone(),
    }));
  };

  removeLegitimationEntry = (index: number) => {
    if (this.state.legitimationEntries.length <= LEGITIMATION_MIN_ENTRIES) return;
    const fieldMap = this.state.fieldMap;
    const payload = this.state.payload;
    const newEntries = this.state.legitimationEntries.filter((_, entryIdx) => entryIdx !== index);
    this.updateLegitimationFieldStates(newEntries, fieldMap);
    const sanitizedEntries = this.sanitizeLegitimationEntriesForPayload(newEntries);
    payload.LegitimationsDetaljer = sanitizedEntries;
    this.updateEnableStateForGranskaOchBetalaButton(fieldMap);

    this.autoSave(fieldMap, payload, {
      legitimationEntries: newEntries,
      certInOtherCountry: this.state.certInOtherCountry,
      showOvrigSpecialistbevisTyp: this.state.showOvrigSpecialistbevisTyp,
    });
  };

  addEarlierSpecialistEntry = () => {
    if (this.state.earlierSpecialistEntries.length >= EARLIER_SPECIALIST_MAX_ENTRIES) return;
    const fieldMap = this.state.fieldMap;
    const newEntries = [...this.state.earlierSpecialistEntries, createEmptyEarlierSpecialistEntry()];
    this.updateEarlierSpecialistFieldStates(newEntries, fieldMap);
    this.updateEnableStateForGranskaOchBetalaButton(fieldMap);

    this.setState((prevState) => ({
      ...prevState,
      earlierSpecialistEntries: newEntries,
      fieldMap: fieldMap.clone(),
    }));
  };

  removeEarlierSpecialistEntry = (index: number) => {
    if (index < 0 || index >= this.state.earlierSpecialistEntries.length) return;
    const fieldMap = this.state.fieldMap;
    const payload = this.state.payload;
    const newEntries = this.state.earlierSpecialistEntries.filter((_, entryIdx) => entryIdx !== index);
    this.updateEarlierSpecialistFieldStates(newEntries, fieldMap);
    const sanitizedEntries = this.sanitizeEarlierSpecialistEntriesForPayload(newEntries);
    payload.SpecialistbevisDetaljer = sanitizedEntries;
    this.updateEnableStateForGranskaOchBetalaButton(fieldMap);

    this.autoSave(fieldMap, payload, {
      earlierSpecialistEntries: newEntries,
      certInOtherCountry: this.state.certInOtherCountry,
      showOvrigSpecialistbevisTyp: this.state.showOvrigSpecialistbevisTyp,
    });
  };

  //we _probably_ don't need to trigger an extra update call here
  onGranskaOchBetalaClick = () => {
    const ansokanId = this.props.ansokan.Id;
    window.location.href = `/${this.props.stepTwoPageLink}/?ansokanId=${ansokanId}`;
  };

  _removeNonExistingFileFromList = () => {
    const fieldMap = this.state.fieldMap.clone();
    fieldMap.removeAllNonExistingFields();
    this.setState({ fieldMap });
  };

  _setPreFileSaveStateInGui = (fieldMap: SpecialistbevisFieldMap, file: FileExtendedDetails, field: FormFieldFile) => {
    file.FileId = null; //trigger the loading file spinner.
    file.status = FileState.UPLOADING;
    this.updateFileState(fieldMap, field);
    fieldMap.setFileErrorMessage(null, field.fieldName);
  };

  updateFileState = (fieldMap: SpecialistbevisFieldMap, field: FormFieldFile) => {
    fieldMap.setFileValueByFieldName(field);
    const fieldState = fieldMap.get(field.fieldName);
    fieldMap.validateFieldWithErrorMessage(fieldState);
  };

  updateEnableStateForGranskaOchBetalaButton = (fieldMap: SpecialistbevisFieldMap) => {
    //NOTE: although the  fieldMap.validateAllFields could be called directly, it is better to have this intermediate method in order to explain the purpose in the GUI of calling it.
    fieldMap.validateAllFields();
  };

  addMultiSelectItem = (selectedItems: MultiSelectItem[]) => {
    const { fieldMap, payload } = this.state;
    payload[SpecialistbevisAnsokanFormFieldName.OtherCertCountries] = selectedItems.map((x) => x.key);
    const fieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.OtherCertCountries);
    fieldState.props.value = selectedItems.map((x) => x.key);

    fieldMap.validateFieldWithErrorMessage(fieldState);

    this.setState(
      {
        fieldMap: fieldMap.clone(),
        payload,
        showSpinner: true,
        isLoading: true,
      },
      () => {
        let partialState = {} as ISpecAnsokanFormState;
        saveAnsokan(this.state.payload, this.API_ROUTE).then((response) => {
          if (response instanceof ResponseError) {
            this._latestResponseError = response;
            partialState.isSaveErrorModalOpen = true;
          } else {
            this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
            partialState.isSaveErrorModalOpen = false;
          }

          this.setState({
            showSpinner: false,
            isLoading: false,
            ...partialState,
          });
        });
      },
    );
  };

  inputChanged = (field: SpecialistbevisAnsokanField) => {
    const { fieldMap, payload } = this.state;
    let fieldName = '';
    let certOtherCountries: boolean | null = null;
    let showOvrigSpecialist: boolean | null = null;
    let updatedLegitimationEntries: LegitimationsDetalj[] | null = null;
    let updatedEarlierSpecialistEntries: SpecialistbevisDetalj[] | null = null;
    //TODO: Why does field.fieldName for radioButtonGroup come as object? Fix the root cause and remove this ugly check :)
    if (typeof field.fieldName === 'object') {
      let fieldData = field as any;
      fieldName = fieldData.fieldName.fieldName;
    } else {
      fieldName = field.fieldName;
    }
    //ENDTODO

    let fieldState = fieldMap.get(field.fieldName);
    fieldState.props.value = field.value;
    fieldMap.validateFieldWithErrorMessage(fieldState);
    this.updateEnableStateForGranskaOchBetalaButton(fieldMap);

    if (field.fieldName === SpecialistbevisAnsokanFormFieldName.ConfirmEmail) {
      this.setState({ fieldMap: fieldMap.clone() });
      return; //We don't save if the confirmation email.
    }

    if (fieldName === SpecialistbevisAnsokanFormFieldName.HasCertInOtherCountry) {
      let otherLegCountry = fieldMap.get(SpecialistbevisAnsokanFormFieldName.OtherCertCountries);

      if (field.value === true) {
        otherLegCountry.props.isRequired = true;
      } else if (field.value === false) {
        otherLegCountry.props.isRequired = false;
        (otherLegCountry.props as any).items = (otherLegCountry.props as any).items.map((x) => ({
          ...x,
          isSelectedByDefault: false,
        }));
        payload[SpecialistbevisAnsokanFormFieldName.OtherCertCountries] = null;
      }
      certOtherCountries = field.value;
    }

    if (fieldName === SpecialistbevisAnsokanFormFieldName.SpecialistbevisType) {
      let otherSpecType = fieldMap.get(SpecialistbevisAnsokanFormFieldName.OvrigSpecialistbevisTyp);

      if (field.value === this.props.specialistBevisTypeOtherId) {
        otherSpecType.props.isRequired = true;
        showOvrigSpecialist = true;
      } else {
        otherSpecType.props.isRequired = false;
        otherSpecType.props.value = '';
        showOvrigSpecialist = false;
        payload[SpecialistbevisAnsokanFormFieldName.OvrigSpecialistbevisTyp] = '';
      }
    }
    const legitimationFieldInfo = this.parseLegitimationFieldName(fieldName);
    const earlierSpecialistFieldInfo = this.parseEarlierSpecialistFieldName(fieldName);
    if (legitimationFieldInfo) {
      const entries = this.updateLegitimationEntriesArray(
        legitimationFieldInfo.index,
        legitimationFieldInfo.key,
        field.value as string,
      );
      updatedLegitimationEntries = entries;
      const sanitizedEntries = this.sanitizeLegitimationEntriesForPayload(entries);
      payload.LegitimationsDetaljer = sanitizedEntries;
      this.updateLegitimationFieldStates(entries, fieldMap);
    } else if (earlierSpecialistFieldInfo) {
      const entries = this.updateEarlierSpecialistEntriesArray(
        earlierSpecialistFieldInfo.index,
        earlierSpecialistFieldInfo.key,
        field.value as string,
      );
      updatedEarlierSpecialistEntries = entries;
      const sanitizedEntries = this.sanitizeEarlierSpecialistEntriesForPayload(entries);
      payload.SpecialistbevisDetaljer = sanitizedEntries;
      this.updateEarlierSpecialistFieldStates(entries, fieldMap);
    } else {
      payload[field.fieldName] = field.value;
      if (field.fieldName === SpecialistbevisAnsokanFormFieldName.GeneralDentalPracticeCountry) {
        payload.TandlakarPraktikDetalj = {
          ...(payload.TandlakarPraktikDetalj ?? {}),
          LandId: (field.value as string) || null,
          Datum: payload.TandlakarPraktikDetalj?.Datum ?? null,
        };
      } else if (field.fieldName === SpecialistbevisAnsokanFormFieldName.GeneralDentalPracticeDate) {
        payload.TandlakarPraktikDetalj = {
          ...(payload.TandlakarPraktikDetalj ?? {}),
          LandId: payload.TandlakarPraktikDetalj?.LandId ?? null,
          Datum: (field.value as string) || null,
        };
      }
    }

    const partialStateOverrides: Partial<ISpecAnsokanFormState> = {
      certInOtherCountry: certOtherCountries ?? this.state.certInOtherCountry,
      showOvrigSpecialistbevisTyp: showOvrigSpecialist ?? this.state.showOvrigSpecialistbevisTyp,
    };

    if (updatedLegitimationEntries) {
      partialStateOverrides.legitimationEntries = updatedLegitimationEntries;
    }

    if (updatedEarlierSpecialistEntries) {
      partialStateOverrides.earlierSpecialistEntries = updatedEarlierSpecialistEntries;
    }

    const errorFieldName =
      field.fieldName === SpecialistbevisAnsokanFormFieldName.Email ? SpecialistbevisAnsokanFormFieldName.Email : null;

    const isGeneralDentalPracticeField =
      field.fieldName === SpecialistbevisAnsokanFormFieldName.GeneralDentalPracticeCountry ||
      field.fieldName === SpecialistbevisAnsokanFormFieldName.GeneralDentalPracticeDate;

    if (isGeneralDentalPracticeField) {
      const landId = payload.TandlakarPraktikDetalj?.LandId;
      const datum = payload.TandlakarPraktikDetalj?.Datum;
      const landIdEmpty = landId == null || landId === '';
      const datumEmpty = datum == null || datum === '';
      if (landIdEmpty || datumEmpty) {
        if (landIdEmpty && datumEmpty) {
          payload.TandlakarPraktikDetalj = undefined;
          this.autoSave(fieldMap, payload, partialStateOverrides, errorFieldName);
        } else {
          this.setState((prevState) => ({
            ...prevState,
            ...partialStateOverrides,
            fieldMap: fieldMap.clone(),
            payload,
          }));
        }
        return;
      }
    }

    this.autoSave(fieldMap, payload, partialStateOverrides, errorFieldName);
  };
  private isPdfFile = (file: File | undefined): boolean => {
    if (!file) return false;
    const name = (file.name ?? '').toLowerCase();
    const type = (file.type ?? '').toLowerCase();
    return name.endsWith('.pdf') || type === 'application/pdf';
  };
  addFile = (field: FormFieldFile) => {
    const { model } = this.props;
    const fieldMap = this.state.fieldMap.clone();
    const file = field.value.filter((f) => !f.FileId)[0];

    // Tillåt endast PDF för svensk specialistbevis
    if (this.props.educationLocation === EducationLocation.EducatedInSweden && !this.isPdfFile(file?.file)) {
      fieldMap.setFileErrorMessage(
        Translations('specialistbevisAnsokan/pdfOnly', 'Endast PDF-filer är tillåtna.'),
        field.fieldName,
      );
      this._removeNonExistingFileFromList();
      this.setState({ fieldMap });
      return;
    }

    this._setPreFileSaveStateInGui(fieldMap, file, field);
    this.setState({ fieldMap, isLoading: true });

    const form = new FormData();
    form.append(file.OriginalFilename, file.file);
    const fileUploadTexts = getFileUploadTexts(model) as FileUploadText;
    const fileUploadText = findFileUploadTextByFieldName(field.fieldName, fileUploadTexts);
    const fileTag = field.fieldName;
    const dhsCategory = fileUploadText?.DHSCategory?.Category;
    const path = `${this.API_ROUTE}/attachbilaga/${this.props.ansokan.Id.toString()}/${fileTag}/${
      this.props.currentLanguage
    }/${dhsCategory ? dhsCategory : ''}`;

    return doPost<FileExtendedDetails>(path, form)
      .then((response) => {
        const fieldMap = this.state.fieldMap.clone();
        let partialState = {} as ISpecAnsokanFormState;
        if (response instanceof ResponseError) {
          this._latestResponseError = response;
          if (response.body.detailCode) {
            partialState.isSaveErrorModalOpen = true;
          } else {
            //only show file error if there is no timeout
            fieldMap.setFileErrorMessage(response.body.errorMessage, field.fieldName);
            this._removeNonExistingFileFromList();
            partialState.isSaveErrorModalOpen = false;
          }
        } else {
          const fileResponse = response as any;
          file.FileId = fileResponse.Id.toString();
          file.status = FileState.SETTLED;
          this.updateFileState(fieldMap, field);
          partialState.isSaveErrorModalOpen = false;
        }
        this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
        this.setState({ fieldMap, isLoading: false, ...partialState });
      })
      .catch((err: ResponseError) => {
        fieldMap.setFileErrorMessage(err.body.errorMessage, field.fieldName); //TODO: Make sure server returns a proper error message to the end user.
        this._removeNonExistingFileFromList();
      });
  };

  removeFile = (file: FileExtendedDetails, fieldName: string, field: FormFieldFile) => {
    const fileId = file.FileId;
    const ansokanId = this.props.ansokan.Id;

    const fieldMap = this.state.fieldMap.clone();
    this._setPreFileSaveStateInGui(fieldMap, file, field);
    this.setState({ fieldMap });

    const path = `${this.API_ROUTE}/deletefile/${fileId}/${ansokanId}`;

    return doDelete<FileExtendedDetails>(path)
      .then((response) => {
        const fieldMap = this.state.fieldMap.clone();
        let partialState = {} as ISpecAnsokanFormState;
        if (response instanceof ResponseError) {
          this._latestResponseError = response;
          if (response.body.detailCode) {
            partialState.isSaveErrorModalOpen = true;
          } else {
            fieldMap.setFileErrorMessage(response.body.errorMessage, field.fieldName);
            file.FileId = fileId;
            file.status = FileState.SETTLED;
            this.updateFileState(fieldMap, field);
            partialState.isSaveErrorModalOpen = false;
          }
        } else {
          const fileResponse = response as any;
          const deletedId = fileResponse.id;
          this._removeNonExistingFileFromList();
          const fieldState = fieldMap.get(field.fieldName);
          fieldMap.validateFieldWithErrorMessage(fieldState);
          partialState.isSaveErrorModalOpen = false;
        }
        this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
        this.setState({ fieldMap, isLoading: false, ...partialState });
        return response;
      })
      .catch((err: ResponseError) => {
        //TODO: Do we need this? I guess it only occurs in case of time out providing that Error handling is done on the server.
        //TODO: Tobias?: Is there a timeout? How is this set in the fetch function?
        fieldMap.setFileErrorMessage(err.body.errorMessage, field.fieldName);
        file.FileId = fileId;
        file.status = FileState.SETTLED;
        this.updateFileState(fieldMap, field);
      });
  };

  onModalClose = () => {
    this.setState({
      isSaveErrorModalOpen: false,
    });
  };

  getAddressInfo = (): JSX.Element => {
    const { formTexts, folkbokforing } = this.props;

    if (folkbokforing) {
      //NOTE: If any error occurs with extracting this info on the server, this object is always null, never otherwise. The server side code takes care of logging the error with information about it.
      return (
        <div className="importantinfo importantinfo--futura m-b-4" aria-label="Dina folkbokföringsuppgifter">
          <div>{folkbokforing.Namn}</div>
          <div>{folkbokforing.PersonNummer}</div>
          {folkbokforing.CareOf && <div>{`c/o ${folkbokforing.CareOf}`}</div>}
          {folkbokforing.Utdelningsadress1 && <div>{folkbokforing.Utdelningsadress1}</div>}
          {folkbokforing.Utdelningsadress2 && <div>{folkbokforing.Utdelningsadress2}</div>}

          <div>
            {folkbokforing.PostNr && <span>{folkbokforing.PostNr}</span>}{' '}
            {folkbokforing.Postort && <span>{folkbokforing.Postort}</span>}
          </div>
        </div>
      );
    }

    return (
      <div className="m-b-4">
        <AttentionBox
          heading={formTexts.PersonuppgifterCouldNotBeLoadedHeading}
          bodytext={formTexts.PersonuppgifterCouldNotBeLoadedBody}
          icon="Info"
          cssClass="attentionbox--red"
        />
      </div>
    );
  };

  onShowAddressClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    this.setState((prevState) => {
      return { showAddressInfo: !prevState.showAddressInfo };
    });
  };

  renderLegitimationEntries = () => {
    return this.state.legitimationEntries.map((_, index) => this.renderLegitimationEntryRow(index));
  };

  renderLegitimationEntryRow = (index: number) => {
    const countryFieldState = this.state.fieldMap.get(getLegitimationCountryFieldName(index));
    const dateFieldState = this.state.fieldMap.get(getLegitimationDateFieldName(index));

    if (!countryFieldState || !dateFieldState) {
      return null;
    }

    return (
      <div className="row m-b-2" key={`legitimation-row-${index}`}>
        <div className="col-sm-5">
          <SelectBox {...(countryFieldState.props as SelectBoxProps)} />
        </div>
        <div className="col-sm-5">
          <TextInput {...(dateFieldState.props as TextInputProps)} />
        </div>
        <div className="col-sm-2 d-flex align-items-end">
          {index > 0 && (
            <button
              type="button"
              className="stripped-button m-t-1 pointer"
              onClick={() => this.removeLegitimationEntry(index)}
              disabled={this.state.legitimationEntries.length <= LEGITIMATION_MIN_ENTRIES}
              aria-label={Translations('specialistbevisAnsokan/legitimationRemoveButton')}
              title={Translations('specialistbevisAnsokan/legitimationRemoveButton')}>
              <Icon iconType="Paperbin" />
            </button>
          )}
        </div>
      </div>
    );
  };

  renderEarlierSpecialistEntries = () => {
    return this.state.earlierSpecialistEntries.map((_, index) => this.renderEarlierSpecialistEntryRow(index));
  };

  renderEarlierSpecialistEntryRow = (index: number) => {
    const specialityFieldState = this.state.fieldMap.get(getEarlierSpecialistSpecialityFieldName(index));
    const countryFieldState = this.state.fieldMap.get(getEarlierSpecialistCountryFieldName(index));
    const dateFieldState = this.state.fieldMap.get(getEarlierSpecialistDateFieldName(index));

    if (!specialityFieldState || !countryFieldState || !dateFieldState) {
      return null;
    }

    return (
      <div className="row m-b-2" key={`earlier-specialist-row-${index}`}>
        <div className="col-sm-4">
          <TextInput {...(specialityFieldState.props as TextInputProps)} />
        </div>
        <div className="col-sm-4">
          <SelectBox {...(countryFieldState.props as SelectBoxProps)} />
        </div>
        <div className="col-sm-3">
          <TextInput {...(dateFieldState.props as TextInputProps)} />
        </div>
        <div className="col-sm-1 d-flex align-items-end">
          <button
            type="button"
            className="stripped-button m-t-1 pointer"
            onClick={() => this.removeEarlierSpecialistEntry(index)}
            aria-label={Translations('specialistbevisAnsokan/earlierSpecialistRemoveButton')}
            title={Translations('specialistbevisAnsokan/earlierSpecialistRemoveButton')}>
            <Icon iconType="Paperbin" />
          </button>
        </div>
      </div>
    );
  };

  autoSave = (
    fieldMap: SpecialistbevisFieldMap,
    payload: SpecialistbevisAnsokanPayload,
    partialStateOverrides: Partial<ISpecAnsokanFormState> = {},
    errorFieldName?: SpecialistbevisAnsokanFormFieldName,
  ) => {
    this.setState(
      (prevState) => ({
        ...prevState,
        fieldMap: fieldMap.clone(),
        payload,
        showSpinner: true,
        isLoading: true,
        certInOtherCountry:
          partialStateOverrides.certInOtherCountry !== undefined
            ? partialStateOverrides.certInOtherCountry
            : prevState.certInOtherCountry,
        showOvrigSpecialistbevisTyp:
          partialStateOverrides.showOvrigSpecialistbevisTyp !== undefined
            ? partialStateOverrides.showOvrigSpecialistbevisTyp
            : prevState.showOvrigSpecialistbevisTyp,
        legitimationEntries: partialStateOverrides.legitimationEntries ?? prevState.legitimationEntries,
        earlierSpecialistEntries: partialStateOverrides.earlierSpecialistEntries ?? prevState.earlierSpecialistEntries,
        isSaveErrorModalOpen: partialStateOverrides.isSaveErrorModalOpen ?? prevState.isSaveErrorModalOpen,
        showAddressInfo:
          partialStateOverrides.showAddressInfo !== undefined
            ? partialStateOverrides.showAddressInfo
            : prevState.showAddressInfo,
      }),
      () => {
        let partialStateUpdates = {} as Partial<ISpecAnsokanFormState>;
        saveAnsokan(payload, this.API_ROUTE).then((response) => {
          if (response instanceof ResponseError) {
            this._latestResponseError = response;
            if (errorFieldName === SpecialistbevisAnsokanFormFieldName.Email) {
              fieldMap.setErrorMessage(response.body.errorMessage, SpecialistbevisAnsokanFormFieldName.Email);
            } else {
              partialStateUpdates.isSaveErrorModalOpen = true;
            }
          } else {
            this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
            partialStateUpdates.isSaveErrorModalOpen = false;
          }

          this.setState((prevState) => ({
            ...prevState,
            showSpinner: false,
            isLoading: false,
            isSaveErrorModalOpen: partialStateUpdates.isSaveErrorModalOpen ?? prevState.isSaveErrorModalOpen,
          }));
        });
      },
    );
  };

  public render() {
    const { model, formTexts, deleteLink, myPage } = this.props;
    const { fieldMap, showSpinner, isLoading, isSaveErrorModalOpen, showAddressInfo } = this.state;
    const legitimationDescriptionId = 'legitimation-section-description';
    const legitimationMaxHintId = 'legitimation-section-max-hint';
    const earlierDescriptionId = 'earlier-specialist-section-description';
    const earlierMaxHintId = 'earlier-specialist-section-max-hint';
    const isLegitimationAtLimit = this.state.legitimationEntries.length >= LEGITIMATION_MAX_ENTRIES;
    const isEarlierSpecialistAtLimit = this.state.earlierSpecialistEntries.length >= EARLIER_SPECIALIST_MAX_ENTRIES;

    const fileupload1FieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.FileUpload1);
    const fileupload2FieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.FileUpload2);
    const fileupload3FieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.FileUpload3);
    const fileupload4FieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.FileUpload4);
    const fileupload5FieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.FileUpload5);
    const fileupload6FieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.FileUpload6);
    const fileupload7FieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.FileUpload7);
    const fileupload8FieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.FileUpload8);
    const fileupload9FieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.FileUpload9);
    const fileupload10FieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.FileUpload10);
    const fileupload11FieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.FileUpload11);
    const fileupload12FieldState = fieldMap.get(SpecialistbevisAnsokanFormFieldName.FileUpload12);
    const showAllmanTandlakarpraktikFields =
      this.props.educationLocation === EducationLocation.EducatedInSweden &&
      this.props.model.OccupationId === SpecialistbevisYrke.Tandlakare;
    const showBastjanstgoringsIntygField =
      this.props.educationLocation === EducationLocation.EducatedInSweden &&
      this.props.model.OccupationId === SpecialistbevisYrke.Lakare &&
      this.props.specialistBevisTyp === SpecialistbevisTyp.LAKARE_HSLF_2021_8;
    const isBastjanstgoring =
      this.props.educationLocation === EducationLocation.EducatedInSweden &&
      this.props.model.OccupationId === SpecialistbevisYrke.Lakare &&
      this.props.specialistBevisTyp !== SpecialistbevisTyp.LAKARE_HSLF_2021_8 &&
      this.props.specialistBevisTyp !== SpecialistbevisTyp.LAKARE_SOSFS_2015_8;
    const shouldShowEducationLocationText = !isBastjanstgoring;
    const educationLocationText =
      this.props.educationLocation === EducationLocation.EducatedOutsideEuEes3year
        ? Translations('specialistbevisAnsokan/educatedOutsideEuEes')
        : this.props.educationLocation === EducationLocation.EducatedInSweden
        ? Translations('specialistbevisAnsokan/educatedInSweden')
        : Translations('specialistbevisAnsokan/educatedInEuEes');
    return (
      <>
        {isSaveErrorModalOpen && (
          <DialogueError
            dialogueErrorBody={getDialogueByResponse(this._latestResponseError, myPage, null, Translations)}
            isModalOpen={isSaveErrorModalOpen}
            onModalClose={this.onModalClose}
            enableCloseIcon={false}
            shouldCloseOnOverlayClick={false}
          />
        )}
        <p className="preamble">
          {isBastjanstgoring
            ? Translations('specialistbevisAnsokan/generalservice')
            : ` ${Translations('specialistbevisAnsokan/preamble')}`}
          <strong>{model.YrkesNamn.toLowerCase()}</strong>{' '}
          {shouldShowEducationLocationText ? ` ${educationLocationText}` : ''}
          {this.props.specialistBevisTyp === SpecialistbevisTyp.LAKARE_HSLF_2021_8
            ? ` ${Translations('specialistbevisAnsokan/HSLFFS20218')}`
            : this.props.specialistBevisTyp === SpecialistbevisTyp.LAKARE_SOSFS_2015_8
            ? ` ${Translations('specialistbevisAnsokan/SOSFS20158')}`
            : ''}
        </p>
        {model.ImportantInformation && (
          <div
            className="importantinfo importantinfo--lightgray importantinfo--sharp"
            dangerouslySetInnerHTML={setInnerHtml(model.ImportantInformation)}
          />
        )}
        <hr />
        {formTexts.PersonuppgifterHeading && <h2>{formTexts.PersonuppgifterHeading}</h2>}
        {formTexts.PersonuppgifterBody && <div dangerouslySetInnerHTML={setInnerHtml(formTexts.PersonuppgifterBody)} />}
        <button className="button button--border m-b-2" onClick={this.onShowAddressClick}>
          {!showAddressInfo ? Translations('showButton') : Translations('hideButton')}{' '}
          {Translations('folkbokforingsadress')}
        </button>
        <div role="log" aria-live="polite">
          {showAddressInfo && this.getAddressInfo()}
        </div>
        <div className="row m-b-2">
          <div className="col-sm-6">
            <TextInput {...(fieldMap.get(SpecialistbevisAnsokanFormFieldName.Email).props as TextInputProps)} />
          </div>
          <div className="col-sm-6">
            <TextInput {...(fieldMap.get(SpecialistbevisAnsokanFormFieldName.ConfirmEmail).props as TextInputProps)} />
          </div>
        </div>
        <hr />

        <section aria-label={Translations('educationSectionHeader')}>
          <h2>{Translations('educationSectionHeader')}</h2>
          {this.props.educationLocation === EducationLocation.EducatedInSweden && (
            <>
              <div className="row m-b-2">
                <div className="col-sm-6">
                  <TextInput
                    {...(this.state.fieldMap.get(SpecialistbevisAnsokanFormFieldName.WorkPlace)
                      .props as TextInputProps)}
                  />
                </div>
                <div className="col-sm-6">
                  <TextInput
                    {...(this.state.fieldMap.get(SpecialistbevisAnsokanFormFieldName.ExaminationDate)
                      .props as TextInputProps)}
                  />
                </div>
              </div>
              {showBastjanstgoringsIntygField && (
                <div className="row m-b-2">
                  <div className="col-sm-6">
                    <TextInput
                      {...(this.state.fieldMap.get(SpecialistbevisAnsokanFormFieldName.GeneralServiceCertificateDate)
                        .props as TextInputProps)}
                    />
                  </div>
                </div>
              )}
            </>
          )}
          {this.props.educationLocation == EducationLocation.EducatedInEuEes && (
            <div className="row m-b-2">
              <div className="col-sm-6">
                <SelectBox
                  {...(this.state.fieldMap.get(SpecialistbevisAnsokanFormFieldName.UtbildningsLand)
                    .props as SelectBoxProps)}
                />
              </div>
            </div>
          )}
          {this.state.fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.SpecialistbevisType) && (
            <div className="row">
              <div className="col-sm-6">
                <ComboboxWithSearchFormControl
                  {...(this.state.fieldMap.get(SpecialistbevisAnsokanFormFieldName.SpecialistbevisType)
                    .props as SelectBoxProps)}
                />
              </div>
            </div>
          )}
          <div className="row m-b-2 m-t-2">
            <div className="col-sm-6">
              {this.state.showOvrigSpecialistbevisTyp && (
                <TextInput
                  {...(fieldMap.get(SpecialistbevisAnsokanFormFieldName.OvrigSpecialistbevisTyp)
                    .props as TextInputProps)}
                />
              )}
            </div>
          </div>
          {this.props.educationLocation === EducationLocation.EducatedInSweden &&
            this.props.specialistBevisTyp !== SpecialistbevisTyp.INTYG_BASTJANSTGORING && (
              <>
                <div className="m-t-3">
                  <h3>{Translations('specialistbevisAnsokan/legitimationSectionHeader')}</h3>
                  <p className="form-hint" id={legitimationDescriptionId}>
                    {Translations('specialistbevisAnsokan/legitimationSectionDescription')}
                  </p>
                  {this.renderLegitimationEntries()}
                  <button
                    type="button"
                    className="button button--border"
                    onClick={this.addLegitimationEntry}
                    disabled={isLegitimationAtLimit}
                    aria-disabled={isLegitimationAtLimit}
                    aria-describedby={
                      isLegitimationAtLimit
                        ? `${legitimationDescriptionId} ${legitimationMaxHintId}`
                        : legitimationDescriptionId
                    }>
                    {Translations('specialistbevisAnsokan/legitimationAddButton')}
                  </button>
                  {isLegitimationAtLimit && (
                    <p className="form-hint m-t-1" id={legitimationMaxHintId}>
                      {Translations('specialistbevisAnsokan/legitimationMaxReached')}
                    </p>
                  )}
                </div>
                <div className="m-t-4">
                  <h3>{Translations('specialistbevisAnsokan/earlierSpecialistSectionHeader')}</h3>
                  <p className="form-hint" id={earlierDescriptionId}>
                    {Translations('specialistbevisAnsokan/earlierSpecialistSectionDescription')}
                  </p>
                  {this.renderEarlierSpecialistEntries()}
                  <button
                    type="button"
                    className="button button--border"
                    onClick={this.addEarlierSpecialistEntry}
                    disabled={isEarlierSpecialistAtLimit}
                    aria-disabled={isEarlierSpecialistAtLimit}
                    aria-describedby={
                      isEarlierSpecialistAtLimit ? `${earlierDescriptionId} ${earlierMaxHintId}` : earlierDescriptionId
                    }>
                    {Translations('specialistbevisAnsokan/earlierSpecialistAddButton')}
                  </button>
                  {isEarlierSpecialistAtLimit && (
                    <p className="form-hint m-t-1" id={earlierMaxHintId}>
                      {Translations('specialistbevisAnsokan/earlierSpecialistMaxReached')}
                    </p>
                  )}
                </div>
                {showAllmanTandlakarpraktikFields && (
                  <>
                    <h3>{Translations('generalDentalPracticeHeader')}</h3>
                    <div className="row m-b-2">
                      <div className="col-sm-6">
                        <SelectBox
                          {...(this.state.fieldMap.get(SpecialistbevisAnsokanFormFieldName.GeneralDentalPracticeCountry)
                            .props as SelectBoxProps)}
                        />
                      </div>
                      <div className="col-sm-6">
                        <TextInput
                          {...(this.state.fieldMap.get(SpecialistbevisAnsokanFormFieldName.GeneralDentalPracticeDate)
                            .props as TextInputProps)}
                        />
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          {this.props.educationLocation !== EducationLocation.EducatedInSweden && (
            <>
              <RadioButtonGroup
                {...this.state.fieldMap.get(SpecialistbevisAnsokanFormFieldName.HasCertInOtherCountry).props}>
                <RadioButton value={true} label={Translations('yesChoice')} />
                <RadioButton value={false} label={Translations('noChoice')} />
              </RadioButtonGroup>
              {this.state.certInOtherCountry && (
                <div className="row m-b-2">
                  <div className="col-sm-6">
                    {
                      <MultiSelectComboboxFormControl
                        {...(this.state.fieldMap.get(SpecialistbevisAnsokanFormFieldName.OtherCertCountries)
                          .props as IMultiSelectComboboxFormControlProps)}
                      />
                    }
                  </div>
                </div>
              )}
            </>
          )}
        </section>
        {fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.FileUpload1) && (
          <>
            <hr />{' '}
            {formTexts.DocumentInfo && (
              <AttentionBox
                cssClass="attentionbox--brown m-b-2 m-t-2"
                icon="Infocirkel_normal20px20px"
                bodytext={formTexts.DocumentInfo}
              />
            )}
            {model.FileUploadText1 && <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText1.IntroText)} />}
            <Fileupload {...(fileupload1FieldState.props as IFileUploadProps)} />
          </>
        )}

        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.FileUpload2) && model.FileUploadText2 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText2.IntroText)} />
              <Fileupload {...(fileupload2FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>

        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.FileUpload3) && model.FileUploadText3 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText3.IntroText)} />
              <Fileupload {...(fileupload3FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>

        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.FileUpload4) && model.FileUploadText4 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText4.IntroText)} />
              <Fileupload {...(fileupload4FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.FileUpload5) && model.FileUploadText5 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText5.IntroText)} />
              <Fileupload {...(fileupload5FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.FileUpload6) && model.FileUploadText6 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText6.IntroText)} />
              <Fileupload {...(fileupload6FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.FileUpload7) && model.FileUploadText7 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText7.IntroText)} />
              <Fileupload {...(fileupload7FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.FileUpload8) && model.FileUploadText8 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText8.IntroText)} />
              <Fileupload {...(fileupload8FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.FileUpload9) && model.FileUploadText9 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText9.IntroText)} />
              <Fileupload {...(fileupload9FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.FileUpload10) && model.FileUploadText10 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText10.IntroText)} />
              <Fileupload {...(fileupload10FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.FileUpload11) && model.FileUploadText11 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText11.IntroText)} />
              <Fileupload {...(fileupload11FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(SpecialistbevisAnsokanFormFieldName.FileUpload12) && model.FileUploadText12 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText12.IntroText)} />
              <Fileupload {...(fileupload12FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
        {model.ExtraInformation && (
          <>
            <hr />
            <div dangerouslySetInnerHTML={setInnerHtml(model.ExtraInformation)} />
          </>
        )}

        <hr />
        <CheckBox {...(fieldMap.get(SpecialistbevisAnsokanFormFieldName.TermsAndConditions).props as CheckBoxProps)} />
        {formTexts.SamtyckeExplanation && <div dangerouslySetInnerHTML={setInnerHtml(formTexts.SamtyckeExplanation)} />}
        <div className="form-submit">
          <button
            className="button relative"
            onClick={this.onGranskaOchBetalaClick}
            disabled={isLoading || !fieldMap.allFieldsAreValid || showSpinner}>
            {Translations('reviewAndPayButton')}
            {showSpinner && <LoadingSpinner cssClasses="button-spinner" />}
          </button>
        </div>
        <hr />
        <div className="delete-order">
          <DeleteButton
            postLink={deleteLink}
            disabled={false}
            actionText={ModalTranslate('delete')}
            cancelText={ModalTranslate('cancel')}
            modalHeading={ModalTranslate('heading')}
            modalBody={ModalTranslate('text')}
          />
        </div>
      </>
    );
  }
}
